import { useQueryParam } from '@psyomics/ui-common';
import { useNavigate, useParams } from 'react-router-dom';

import { Report as ReportFeature } from '../../../features/reports/report';

const Report = () => {
  const { referralId, referralSessionId, '*': path } = useParams();
  const navigate = useNavigate();
  const referrer = useQueryParam('referrer');

  if (!referralId) throw new Error('no referral id');

  return (
    <ReportFeature
      navigateToPath={navigate}
      path={path}
      referralId={referralId}
      referralSessionId={referralSessionId}
      referrer={referrer}
    />
  );
};

export { Report };
